import axios from 'axios';

export const duplicateProduct = (brandId: number, productId: number) => {
  return axios.post(`/api/brands/${brandId}/products/${productId}/duplicate`);
};
